



























import Vue from "vue";

import AdBanner from "@/parts/util/AdBanner.vue";

interface Menu {
  title: string;
  list: MenuItem[];
}

interface MenuItem {
  to: string;
  name: string;
  /**
   * NOTE: 外部リンクの場合は anchor を指定してください
   *       デフォルトは router-link です
   */
  elementType?: "anchor" | "router-link";
  /** NOTE: 特殊なURLの判定をする為に正規表現を追加 */
  regex?: RegExp;
}

export default Vue.extend({
  name: "SideBar",
  components: {
    AdBanner,
  },
  props: {
    menuName: String,
  },
  data() {
    let menu: Menu[];
    if (this.menuName == "guide") {
      menu = [
        {
          title: "概要",
          list: [
            { to: "/guide", name: "基本情報" },
            { to: "/guide/register", name: "会員に関する情報" },
          ],
        },
        {
          title: "レビューを受注する",
          list: [
            // { to: "/guide/accept/prompted", name: "受注までの流れ（即決形式）" },
            { to: "/guide/accept/tenders", name: "受注までの流れ" },
            // { to: "/guide/accept/tenders", name: "受注までの流れ（入札形式）" },
            { to: "/guide/accept/deal", name: "取引の流れ" },
            { to: "/guide/accept/confirm", name: "売上金を確認する" },
            { to: "/guide/accept/transfer", name: "売上金の入金" },
          ],
        },
        {
          title: "レビューを依頼する",
          list: [
            // { to: "/guide/review/prompted", name: "依頼作成の流れ（即決形式）" },
            { to: "/guide/review/tenders", name: "依頼作成の流れ" },
            // { to: "/guide/review/tenders", name: "依頼作成の流れ（入札形式）" },
            { to: "/guide/review/deal", name: "取引の流れ" },
            { to: "/guide/review/edit", name: "依頼の編集・削除" },
          ],
        },
        {
          title: "各種設定",
          list: [
            { to: "/guide/settings", name: "プロフィール・スキルの設定" },
            { to: "/guide/settings/theme", name: "コードテーマの設定" },
            { to: "/guide/settings/mailaddress", name: "メールアドレスの変更" },
            { to: "/guide/settings/phoneNumber", name: "電話番号の変更" },
            { to: "/guide/settings/password", name: "パスワードの変更" },
            { to: "/guide/settings/twoFactor", name: "二要素認証の設定" },
            { to: "/guide/settings/leave", name: "退会方法" },
          ],
        },
      ];
    } else {
      menu = [
        {
          title: "ABOUT",
          list: [
            // NOTE: GUIDを判定する為の正規表現
            { to: "/announcements", name: "お知らせ", regex: new RegExp(/^\/announcements\/([0-9a-f]{8})-([0-9a-f]{4})-([0-9a-f]{4})-([0-9a-f]{4})-([0-9a-f]{12})$/) },
            { to: "/question", name: "よくある質問" },
            { to: "/contact", name: "お問い合わせ" },
            { to: "https://idh-net.co.jp/about/", name: "運営会社", elementType: "anchor" },
          ],
        },
        {
          title: "TERMS",
          list: [
            { to: "/terms", name: "利用規約" },
            { to: "/privacy", name: "個人情報の取り扱いについて" },
            { to: "/law", name: "特定商取引法に基づく表記" },
          ],
        },
      ];
    }
    return {
      menu,
    };
  },
  methods: {
    current(item: MenuItem, path: string) {
      let current = false; 
      if (item.regex) {
        current = item.regex.test(path);
      }
      if (!current) {
        current = item.to == path;
      }
      return current;
    }
  },
});
